import { useEffect, useState } from 'react';
import { PageHeaderWrapper } from '../../../../../app/header/PageHeaderWrapper';
import { PageHeaderProps } from '@splunk/olly-common';
import { DetectorPageHeaderEdit } from './DetectorPageHeaderEdit';
import styled from 'styled-components';
import {
    ResolutionPill,
    ResolutionPillProps,
} from '../../../charting/chartdisplay/tableChart/chartDirectives';

const StyledDetectorEditTitleContainer = styled.div`
    display: flex;
    align-items: center;
`;

const StyledResolutionPillContainer = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    width: 30px;
`;

const StyledDetectorPageHeaderDescription = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

type DetectorPageHeaderWrapperProps = Pick<PageHeaderProps, 'navigation'> & {
    description?: string;
    name?: string;
    resolutionData: ResolutionPillProps;
    update: (params: { name?: string; description?: string }) => void;
};

export const DetectorPageHeaderWrapper = ({
    description: rawDescription,
    name: rawName,
    navigation: rawNavigation,
    resolutionData,
    update,
}: DetectorPageHeaderWrapperProps): JSX.Element => {
    const [navigation, setNavigation] = useState(rawNavigation);
    const [name, setName] = useState(rawName);
    const [description, setDescription] = useState(rawDescription);

    useEffect(() => {
        setDescription(rawDescription);
    }, [rawDescription]);

    useEffect(() => {
        setName(rawName);
    }, [rawName]);

    useEffect(() => {
        setNavigation(
            (rawNavigation ?? [])
                .slice(0, -1)
                .concat({ ...rawNavigation.slice(-1)?.[0], label: rawName })
        );
    }, [rawNavigation, rawName]);

    const updateWrapper = ({
        name,
        description,
    }: {
        name?: string;
        description?: string;
    }): void => {
        setNavigation(
            (navigation ?? []).slice(0, -1).concat({ ...navigation.slice(-1)?.[0], label: name })
        );
        setDescription(description);
        setName(name);
        update({ name, description });
    };

    return (
        <PageHeaderWrapper
            navigation={navigation}
            description={
                <StyledDetectorPageHeaderDescription>
                    {description}
                </StyledDetectorPageHeaderDescription>
            }
            titleContent={
                <StyledDetectorEditTitleContainer>
                    <DetectorPageHeaderEdit
                        name={name}
                        update={updateWrapper}
                        description={description}
                    />
                    {
                        // Always take up space even if not defined to avoid shoving around other elements
                    }
                    {
                        <StyledResolutionPillContainer>
                            <ResolutionPill
                                misalignedResolution={resolutionData.misalignedResolution}
                                resolution={resolutionData.resolution}
                                rollupMessage={resolutionData.rollupMessage}
                                alternateTooltipText={resolutionData.alternateTooltipText}
                            />
                        </StyledResolutionPillContainer>
                    }
                </StyledDetectorEditTitleContainer>
            }
        />
    );
};
